// src/components/PendingAppointments.js
import React from 'react';

const PendingAppointments = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800">Pending Appointments</h2>
        <a href="#" className="text-orange-500 hover:underline text-sm font-medium">View All</a>
      </div>

      {/* Appointment Item */}
      <div className="flex items-center justify-between p-4 bg-gray-50 rounded-md border border-gray-200">
        <div>
          <p className="text-gray-900 font-medium">Priya Sharma</p>
          <p className="text-gray-600 text-sm">Yoga Session</p>
          <p className="text-gray-500 text-xs flex items-center mt-1">
            <svg
              className="w-4 h-4 mr-1 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              ></path>
            </svg>
            Today, 2:00 PM
          </p>
        </div>
        <div className="flex space-x-2">
          <button className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium py-1 px-3 rounded-md">
            Accept
          </button>
          <button className="bg-red-500 hover:bg-red-600 text-white text-sm font-medium py-1 px-3 rounded-md">
            Decline
          </button>
        </div>
      </div>

      {/* You can add more appointment items here */}
    </div>
  );
};

export default PendingAppointments;